'use strict';

const _ = require('lodash');

const cashflowComponent = require('../components/cashflow');
const actions = require('./actions');
const consts = require('../consts');

function _initOptimistic(cashflow) {
  return cashflowComponent.create(_.cloneDeep(cashflow));
}

function _returnUpdated(cashflow) {
  return cashflow.toJson();
}

function validateInputNotNull(input) {
  if (_.isUndefined(input)) {
    throw new Error('Got undefined input in Optimus');
  }
}

function cancelEnvelope(cashflow, { envelopeId }) {
  validateInputNotNull(envelopeId);
  const oc = _initOptimistic(cashflow);
  actions.cancelEnvelope(oc, envelopeId);
  return _returnUpdated(oc);
}

function updateEnvelopeAmount(cashflow, { envelopeId, amount }) {
  validateInputNotNull(envelopeId);
  const oc = _initOptimistic(cashflow);
  actions.updateEnvelopeAmount(oc, envelopeId, amount);
  return _returnUpdated(oc);
}

function updateRiseupGoal(cashflow, { amount }) {
  const oc = _initOptimistic(cashflow);
  actions.updateRiseupGoalAmount(oc, amount);
  return _returnUpdated(oc);
}

function moveVariableExpenseToFixed(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveVariableExpenseToFixed(oc, transactionId);
  return _returnUpdated(oc);
}

function moveExpenseToFixed(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveExpenseToFixed(oc, transactionId);
  return _returnUpdated(oc);
}

function moveFixedToVariable(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveFixedToVariable(oc, transactionId);
  return _returnUpdated(oc);
}

function excludeExpense(cashflow, { transactionId, popExpense }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.excludeExpense(oc, transactionId, popExpense);
  return _returnUpdated(oc);
}

function moveVariableIncomeToFixed(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveVariableIncomeToFixed(oc, transactionId);
  return _returnUpdated(oc);
}

function moveExcludedToVariableExpense(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveExcludedToVariableExpense(oc, transactionId);
  return _returnUpdated(oc);
}

function moveExcludedToVariableIncome(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.moveExcludedToVariableIncome(oc, transactionId);
  return _returnUpdated(oc);
}

function excludeVariableExpense(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.excludeVariableExpense(oc, transactionId);
  return _returnUpdated(oc);
}

function excludeVariableIncome(cashflow, { transactionId }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.excludeVariableIncome(oc, transactionId);
  return _returnUpdated(oc);
}

function changeCategory(cashflow, { businessName, expense, transactionId, applyTo, popEnvelope }) {
  if (applyTo === consts.ENRICHMENT_INPUT_TYPES.TRANSACTION_ID) {
    validateInputNotNull(transactionId);
  } else {
    validateInputNotNull(businessName);
  }
  const oc = _initOptimistic(cashflow);
  actions.changeCategory(oc, businessName, expense, transactionId, applyTo, popEnvelope);
  return _returnUpdated(oc);
}

function changeTransactionCategory(cashflow, { trackingCategoryId, matchBy, value, popEnvelope }) {
  const oc = _initOptimistic(cashflow);
  actions.changeTransactionCategory(oc, trackingCategoryId, matchBy, value, popEnvelope);
  return _returnUpdated(oc);
}

function moveFromTracking(cashflow, { matchBy, value }) {
  const oc = _initOptimistic(cashflow);
  actions.moveFromTracking(cashflow, matchBy, value);
  return _returnUpdated(oc);
}

function disableTrackingCategory(cashflow, { envelopeId }) {
  const oc = _initOptimistic(cashflow);
  actions.cancelEnvelope(oc, envelopeId);
  return _returnUpdated(oc);
}

function changeEnvelopeExpenseCategory(cashflow, { envelopeId, expenseCategory }) {
  validateInputNotNull(envelopeId);
  validateInputNotNull(expenseCategory);
  const oc = _initOptimistic(cashflow);
  actions.changeEnvelopeExpenseCategory(oc, envelopeId, expenseCategory);
  return _returnUpdated(oc);
}

function setIncomePredictionAmount(cashflow, { amount }) {
  validateInputNotNull(amount);
  const oc = _initOptimistic(cashflow);
  actions.setIncomePredictionAmount(oc, amount);
  return _returnUpdated(oc);
}

function setTransactionComment(cashflow, { transactionId, comment }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  actions.setTransactionComment(oc, transactionId, comment);
  return _returnUpdated(oc);
}

function splitTransaction(cashflow, { transactionId, slices }) {
  validateInputNotNull(transactionId);
  const oc = _initOptimistic(cashflow);
  // TODO implement
  return _returnUpdated(oc);
}

function showTrackingCategory(cashflow, { amount, name, trackingCategoryId, icon, frequency }) {
  validateInputNotNull(amount);
  validateInputNotNull(name);
  validateInputNotNull(trackingCategoryId);
  validateInputNotNull(icon);
  const oc = _initOptimistic(cashflow);
  actions.showTrackingCategory(oc, name, amount, trackingCategoryId, icon, frequency);
  return _returnUpdated(oc);
}

module.exports = {
  cancelEnvelope,
  updateEnvelopeAmount,
  updateRiseupGoal,
  moveVariableExpenseToFixed,
  moveVariableIncomeToFixed,
  moveExcludedToVariableExpense,
  moveExcludedToVariableIncome,
  excludeVariableExpense,
  excludeVariableIncome,
  setIncomePredictionAmount,
  changeCategory,
  changeTransactionCategory,
  moveFromTracking,
  disableTrackingCategory,
  changeEnvelopeExpenseCategory,
  moveFixedToVariable,
  showTrackingCategory,
  setTransactionComment,
  splitTransaction,
  excludeExpense,
  moveExpenseToFixed,
};
